// extracted by mini-css-extract-plugin
export default {"componentWrapper":"DefaultLayout_componentWrapper__LxEdh","logo":"DefaultLayout_logo__tYuIf"};